import { useEffect, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import './Sample.scss';

type ThemeSample = {
  theme: string;
  num: string;
  prefix: string;
  em: string;
  tags: string[];
  swatches: { color: string; hex: string }[];
  desc: string;
  logo: string;
  coverTitle: string;
  coverEn: string;
  sermon: string;
  sermonMeta: string;
  biblePicker: string;
  verseHtml: string;
  news: { title: string; date: string }[];
  order: { label: string; num: string }[];
  chips: string[];
};

const THEMES: ThemeSample[] = [
  {
    theme: 'theme-navy',
    num: 'Sample 01',
    prefix: 'Classic',
    em: 'Navy',
    tags: ['정통', '전통', '대형교회'],
    swatches: [
      { color: '#0d2b5e', hex: '0D2B5E' },
      { color: '#f3ede1', hex: 'F3EDE1' },
      { color: '#fafaf7', hex: 'FAFAF7' },
    ],
    desc: '깊은 네이비와 크림의 조화. 오랜 역사를 가진 교회에 어울리는 정통 클래식.',
    logo: '새생명교회',
    coverTitle: '주일예배',
    coverEn: 'Sunday Worship',
    sermon: '은혜 위에 은혜',
    sermonMeta: 'Rev. Kim Yohan · 07·19',
    biblePicker: '요한복음 3장',
    verseHtml:
      '<span class="vn">1</span>그런데 바리새인 중에 니고데모라 하는 사람이 있으니 유대인의 지도자라 <span class="vn">2</span>그가 밤에 예수께 와서 이르되 랍비여 우리가 당신은 하나님께로부터 오신 선생인 줄 아나이다 <span class="vn">3</span>예수께서 대답하여 이르시되 진실로 진실로 네게 이르노니 사람이 거듭나지 아니하면 하나님의 나라를 볼 수 없느니라',
    news: [
      { title: '2026 여름수련회 안내', date: '07·22' },
      { title: '특별 찬양대 예배', date: '07·19' },
      { title: '김요한 집사 감사 인사', date: '07·18' },
      { title: '주보 발행 안내', date: '07·17' },
    ],
    order: [
      { label: '예배 부름', num: '01' },
      { label: '신앙 고백', num: '02' },
      { label: '찬 송', num: '03' },
      { label: '대표 기도', num: '04' },
      { label: '성경 봉독', num: '05' },
      { label: '설 교', num: '06' },
      { label: '축 도', num: '07' },
    ],
    chips: ['전체', '공지', '행사', '감사'],
  },
  {
    theme: 'theme-sepia',
    num: 'Sample 02',
    prefix: 'Warm',
    em: 'Sepia',
    tags: ['따뜻함', '연륜', '시골교회'],
    swatches: [
      { color: '#8a6a3b', hex: '8A6A3B' },
      { color: '#f3ede1', hex: 'F3EDE1' },
      { color: '#f6efe2', hex: 'F6EFE2' },
    ],
    desc: '세피아 톤의 따뜻한 감성. 시골과 중소형 교회에 어울리는 아날로그의 온기.',
    logo: '평강교회',
    coverTitle: '주일예배',
    coverEn: 'Sunday Worship',
    sermon: '오래된 길로 걸으라',
    sermonMeta: 'Rev. Lee · 07·19',
    biblePicker: '예레미야 6장',
    verseHtml:
      '<span class="vn">16</span>여호와께서 이같이 말씀하시되 너희는 길에 서서 보며 옛적 길 곧 선한 길이 어디인지 알아보고 그리로 행하라 너희 심령이 평강을 얻으리라',
    news: [
      { title: '추수감사절 예배 안내', date: '07·22' },
      { title: '구역 모임 일정 변경', date: '07·19' },
      { title: '성도 심방 일정', date: '07·18' },
      { title: '주보 발행 안내', date: '07·17' },
    ],
    order: [
      { label: '예배 부름', num: '01' },
      { label: '신앙 고백', num: '02' },
      { label: '찬 송', num: '03' },
      { label: '대표 기도', num: '04' },
      { label: '성경 봉독', num: '05' },
      { label: '설 교', num: '06' },
      { label: '축 도', num: '07' },
    ],
    chips: ['전체', '공지', '행사', '감사'],
  },
  {
    theme: 'theme-mono',
    num: 'Sample 03',
    prefix: 'Modern',
    em: 'Mono',
    tags: ['미니멀', '도심형', '청년'],
    swatches: [
      { color: '#111111', hex: '111111' },
      { color: '#ffffff', hex: 'FFFFFF' },
      { color: '#f4f4f2', hex: 'F4F4F2' },
    ],
    desc: '흑백의 미니멀리즘. 도심형 교회와 젊은 회중에 어울리는 현대적 표정.',
    logo: 'CITY CHURCH',
    coverTitle: 'WORSHIP',
    coverEn: 'Sunday Service',
    sermon: 'Grace upon Grace',
    sermonMeta: 'Pastor Kim · 07.19',
    biblePicker: 'John 3',
    verseHtml:
      '<span class="vn">1</span>Now there was a Pharisee, a man named Nicodemus who was a member of the Jewish ruling council. <span class="vn">2</span>He came to Jesus at night and said, “Rabbi, we know that you are a teacher who has come from God.”',
    news: [
      { title: 'Summer Retreat 2026', date: '07.22' },
      { title: 'Special Worship Night', date: '07.19' },
      { title: 'Volunteer Open Call', date: '07.18' },
      { title: 'Weekly Bulletin', date: '07.17' },
    ],
    order: [
      { label: 'Call to Worship', num: '01' },
      { label: 'Confession', num: '02' },
      { label: 'Song', num: '03' },
      { label: 'Prayer', num: '04' },
      { label: 'Scripture', num: '05' },
      { label: 'Sermon', num: '06' },
      { label: 'Benediction', num: '07' },
    ],
    chips: ['All', 'Notice', 'Event', 'Thanks'],
  },
  {
    theme: 'theme-cobalt',
    num: 'Sample 04',
    prefix: 'Youth',
    em: 'Cobalt',
    tags: ['청년', '활력', '대학부'],
    swatches: [
      { color: '#2c4cff', hex: '2C4CFF' },
      { color: '#ffd34e', hex: 'FFD34E' },
      { color: '#eef2fb', hex: 'EEF2FB' },
    ],
    desc: '코발트 블루와 옐로우 포인트. 청년·대학부에 어울리는 에너지 넘치는 컨셉.',
    logo: '비전청년교회',
    coverTitle: '청년예배',
    coverEn: 'Youth Worship',
    sermon: '너의 청춘을',
    sermonMeta: 'Rev. Park · 07·19',
    biblePicker: '전도서 12장',
    verseHtml:
      '<span class="vn">1</span>너는 <span class="hl">청년의 때</span> 곧 곤고한 날이 이르기 전, 나는 아무 낙이 없다고 할 해가 가깝기 전에 너의 창조자를 기억하라',
    news: [
      { title: '여름수련회 신청 OPEN', date: '07·22' },
      { title: '토요 찬양팀 모집', date: '07·19' },
      { title: '새가족 환영회', date: '07·18' },
      { title: '주보 발행 안내', date: '07·17' },
    ],
    order: [
      { label: '예배 부름', num: '01' },
      { label: '찬 양', num: '02' },
      { label: '대표 기도', num: '03' },
      { label: '성경 봉독', num: '04' },
      { label: '설 교', num: '05' },
      { label: '응답 찬양', num: '06' },
      { label: '파 송', num: '07' },
    ],
    chips: ['전체', '공지', '행사', '감사'],
  },
  {
    theme: 'theme-sage',
    num: 'Sample 05',
    prefix: 'Sage',
    em: 'Green',
    tags: ['자연', '평온', '가정교회'],
    swatches: [
      { color: '#6b7f5f', hex: '6B7F5F' },
      { color: '#e8efe3', hex: 'E8EFE3' },
      { color: '#f4f7f1', hex: 'F4F7F1' },
    ],
    desc: '세이지 그린의 평온함. 가정교회와 자연을 사랑하는 공동체에 어울리는 온화한 톤.',
    logo: '숲가정교회',
    coverTitle: '가정예배',
    coverEn: 'Family Worship',
    sermon: '쉼표를 찍는 신앙',
    sermonMeta: 'Rev. Choi · 07·19',
    biblePicker: '시편 23편',
    verseHtml:
      '<span class="vn">1</span>여호와는 나의 목자시니 내게 부족함이 없으리로다 <span class="vn">2</span>그가 나를 푸른 풀밭에 누이시며 쉴 만한 물 가로 인도하시는도다',
    news: [
      { title: '여름 가족캠프 안내', date: '07·22' },
      { title: '가정예배 가이드', date: '07·19' },
      { title: '이웃 돌봄 나눔', date: '07·18' },
      { title: '주보 발행 안내', date: '07·17' },
    ],
    order: [
      { label: '예배 부름', num: '01' },
      { label: '신앙 고백', num: '02' },
      { label: '찬 송', num: '03' },
      { label: '대표 기도', num: '04' },
      { label: '성경 봉독', num: '05' },
      { label: '설 교', num: '06' },
      { label: '축 도', num: '07' },
    ],
    chips: ['전체', '공지', '행사', '감사'],
  },
  {
    theme: 'theme-burgundy',
    num: 'Sample 06',
    prefix: 'Bilingual',
    em: 'Burgundy',
    tags: ['국제', '한인교회', '다국어'],
    swatches: [
      { color: '#6e1f2e', hex: '6E1F2E' },
      { color: '#f3ede1', hex: 'F3EDE1' },
      { color: '#faf6f4', hex: 'FAF6F4' },
    ],
    desc: '버건디의 품격. 한인·국제 교회를 위한 한국어/영어 병기 컨셉.',
    logo: '벧엘한인교회',
    coverTitle: '주일예배',
    coverEn: 'Sunday Worship',
    sermon: '은혜 위에 은혜',
    sermonMeta: 'Rev. Kim · 07·19',
    biblePicker: 'John 3 · 요한복음',
    verseHtml:
      '<span class="vn">1</span>그런데 바리새인 중에 니고데모라 하는 사람이 있으니 유대인의 지도자라 <span class="bilingual">Now there was a Pharisee, a man named Nicodemus…</span>',
    news: [
      { title: 'Summer Retreat 2026', date: '여름수련회 · 07·22' },
      { title: 'Special Choir Sunday', date: '특별찬양 · 07·19' },
      { title: 'Newcomers Gathering', date: '새가족 · 07·18' },
      { title: 'Weekly Bulletin', date: '주보 · 07·17' },
    ],
    order: [
      { label: 'Call to Worship', num: '01' },
      { label: 'Confession', num: '02' },
      { label: 'Hymn', num: '03' },
      { label: 'Prayer', num: '04' },
      { label: 'Scripture', num: '05' },
      { label: 'Sermon', num: '06' },
      { label: 'Benediction', num: '07' },
    ],
    chips: ['All', 'Notice', 'Event', 'Thanks'],
  },
];

const COMPARE = [
  { name: 'Classic Navy', color: '#0d2b5e', tags: 'Traditional · Large' },
  { name: 'Warm Sepia', color: '#8a6a3b', tags: 'Warm · Rural' },
  { name: 'Modern Mono', color: '#111', tags: 'Minimal · Urban' },
  { name: 'Youth Cobalt', color: '#2c4cff', tags: 'Young · Energetic' },
  { name: 'Sage Green', color: '#6b7f5f', tags: 'Natural · Family' },
  { name: 'Bilingual Burgundy', color: '#6e1f2e', tags: 'International · KR/EN' },
];

function PhoneChrome({
  logo,
  activeTab,
  children,
}: {
  logo: string;
  activeTab: number;
  children: ReactNode;
}) {
  const tabs = ['홈', '주보', '성경', '설교', '더보기'];
  return (
    <div className="phone">
      <div className="p-status">
        <span>9:41</span>
        <span className="icons" />
      </div>
      <div className="p-nav">
        <span className="logo">{logo}</span>
        <span className="more">•••</span>
      </div>
      <div className="p-body">{children}</div>
      <div className="p-tabs">
        {tabs.map((tab, index) => (
          <div className={`p-tab${index === activeTab ? ' on' : ''}`} key={tab}>
            <span className="ico" />
            {tab}
          </div>
        ))}
      </div>
    </div>
  );
}

function ThemePhones({ sample }: { sample: ThemeSample }) {
  return (
    <div className="phone-row">
      <div>
        <PhoneChrome logo={sample.logo} activeTab={1}>
          <div className="p-cover">
            <div className="p-cover-date">2026 · 07 · 19 SUN</div>
            <div className="p-cover-title">{sample.coverTitle}</div>
            <div className="p-cover-en">{sample.coverEn}</div>
          </div>
          <div className="p-order-label">Order of Service</div>
          <ul className="p-order">
            {sample.order.map((item) => (
              <li key={item.num}>
                {item.label} <small>{item.num}</small>
              </li>
            ))}
          </ul>
        </PhoneChrome>
        <div className="phone-caption">01 · Bulletin</div>
      </div>

      <div>
        <PhoneChrome logo={sample.logo} activeTab={2}>
          <div className="p-section-title">교회소식</div>
          <div className="p-chips">
            {sample.chips.map((chip, index) => (
              <span className={`p-chip${index === 0 ? ' on' : ''}`} key={chip}>
                {chip}
              </span>
            ))}
          </div>
          <ul className="p-news">
            {sample.news.map((item) => (
              <li key={item.title}>
                <div className="thumb" />
                <div className="meta">
                  <strong>{item.title}</strong>
                  <small>{item.date}</small>
                </div>
              </li>
            ))}
          </ul>
        </PhoneChrome>
        <div className="phone-caption">02 · News</div>
      </div>

      <div>
        <PhoneChrome logo={sample.logo} activeTab={2}>
          <div className="p-section-title">성경읽기</div>
          <div className="p-bible-picker">{sample.biblePicker}</div>
          <div
            className="p-verses"
            dangerouslySetInnerHTML={{ __html: sample.verseHtml }}
          />
          <div className="p-bible-ctrl">
            <span>A−</span>
            <span>A+</span>
            <span>♡</span>
            <span>↗</span>
          </div>
        </PhoneChrome>
        <div className="phone-caption">03 · Bible</div>
      </div>

      <div>
        <PhoneChrome logo={sample.logo} activeTab={3}>
          <div className="p-section-title">설교영상</div>
          <div className="p-video">
            <div className="p-play" />
            <div className="p-duration">36:24</div>
          </div>
          <div className="p-sermon-title">{sample.sermon}</div>
          <div className="p-sermon-meta">{sample.sermonMeta}</div>
          <ul className="p-chapters">
            <li>
              서 론 <small>00:00</small>
            </li>
            <li>
              본문 봉독 <small>02:14</small>
            </li>
            <li>
              본문 해석 <small>08:32</small>
            </li>
            <li>
              적 용 <small>19:04</small>
            </li>
          </ul>
        </PhoneChrome>
        <div className="phone-caption">04 · Sermon</div>
      </div>
    </div>
  );
}

export default function Sample() {
  useEffect(() => {
    const nodes = document.querySelectorAll('.sample-page .reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    nodes.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="sample-page">
      <Header />

      <section className="page-header">
        <div className="container reveal">
          <div className="breadcrumb">
            <Link to="/">Home</Link> <span>· Sample</span>
          </div>
          <div className="page-header-grid">
            <div>
              <h1 className="page-title">
                같은 기능,
                <br />
                다른 <span className="em">얼굴</span>.
              </h1>
              <p className="page-sub">
                모든 샘플은 <b>온라인주보 · 교회소식 · 성경읽기 · 설교영상</b> 네
                가지 핵심 서비스를 동일하게 담고 있습니다. 교회의 성격에 맞춰,
                컨셉과 색상만 달라집니다.
              </p>
            </div>
            <div className="page-meta">
              <strong>06</strong>
              Concepts · 24 Screens
            </div>
          </div>
        </div>
      </section>

      {THEMES.map((sample) => (
        <section className={`sample ${sample.theme}`} key={sample.theme}>
          <div className="container">
            <div className="sample-grid reveal">
              <div className="sample-info">
                <span className="sample-num">{sample.num}</span>
                <h2 className="sample-name">
                  {sample.prefix} <em>{sample.em}</em>
                </h2>
                <div className="swatches">
                  {sample.swatches.map((swatch) => (
                    <div className="swatch" key={swatch.hex}>
                      <div
                        className="swatch-dot"
                        style={{ background: swatch.color }}
                      />
                      <div className="swatch-hex">{swatch.hex}</div>
                    </div>
                  ))}
                </div>
                <div className="sample-tags">
                  {sample.tags.map((tag) => (
                    <span className="sample-tag" key={tag}>
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="sample-desc">{sample.desc}</p>
              </div>
              <div>
                <ThemePhones sample={sample} />
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className="glance">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow light">At a Glance</span>
            <h2>
              6가지 컨셉,
              <br />
              <span className="em">한눈에</span>.
            </h2>
          </div>
          <div className="compare-scroll reveal">
          <table className="compare-table">
            <thead>
              <tr>
                <th style={{ width: '26%' }}>Concept</th>
                <th style={{ width: '13%' }}>온라인주보</th>
                <th style={{ width: '13%' }}>교회소식</th>
                <th style={{ width: '13%' }}>성경읽기</th>
                <th style={{ width: '13%' }}>설교영상</th>
                <th>Best for</th>
              </tr>
            </thead>
            <tbody>
              {COMPARE.map((row) => (
                <tr key={row.name}>
                  <td>
                    <span className="concept-name">
                      <span
                        className="concept-dot"
                        style={{ background: row.color }}
                      />
                      {row.name}
                    </span>
                  </td>
                  <td className="check">✓</td>
                  <td className="check">✓</td>
                  <td className="check">✓</td>
                  <td className="check">✓</td>
                  <td className="tags">{row.tags}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </section>

      <section className="final-cta" id="contact">
        <div className="container final-cta-inner reveal">
          <h2>
            당신의 교회는,
            <br />
            어떤 <span className="em">얼굴</span>인가요?
          </h2>
          <p>신청서를 남기고, 우리 교회에 맞는 컨셉을 찾아보세요.</p>
          <Link to="/inquiry" className="btn-cream">
            신청하기 &nbsp;→
          </Link>
        </div>
      </section>

      <ScrollToTopButton />
      <Footer />
    </div>
  );
}
